import BlurOn from "@mui/icons-material/BlurOn";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import type { Theme } from "@mui/material";
import type { ComponentProps } from "react";

import { makeSvgIcon } from "./svg-icon";

const getMainDesignColor = (theme: Theme) => theme.palette.design.main;

const GenericIcon = makeSvgIcon(BlurOn, getMainDesignColor);

const COMPONENT_MAP = {
  composite: makeSvgIcon(GridViewIcon, getMainDesignColor),
  "multi-step": makeSvgIcon(SchemaOutlinedIcon, getMainDesignColor),
  "search-list": makeSvgIcon(ListIcon, getMainDesignColor),
} as const;

export function SearchSpaceIcon({
  type,
  ...props
}: ComponentProps<typeof GenericIcon> & {
  type?: keyof typeof COMPONENT_MAP;
}) {
  const Component = type ? COMPONENT_MAP[type] : GenericIcon;
  return <Component {...props} />;
}

export default SearchSpaceIcon;
